import React from 'react';
import { ACCESS_CHIP, ACCESS_LABEL, type CapabilityMap, type PlatformAccess } from '../capabilitiesUi';

export type RolePresetOption = {
  id: string;
  name: string;
  description: string;
  default_platform_access: PlatformAccess;
  capabilities?: CapabilityMap;
};

type RolePresetGridProps = {
  presets: RolePresetOption[];
  value: string;
  onChange: (presetId: string) => void;
};

export function RolePresetGrid({ presets, value, onChange }: RolePresetGridProps) {
  return (
    <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
      {presets.map((preset) => {
        const selected = preset.id === value;
        return (
          <button
            key={preset.id}
            type="button"
            onClick={() => onChange(preset.id)}
            className={`relative rounded-xl border p-3 pl-10 text-left transition-colors ${
              selected
                ? 'border-pipedrive-blue bg-blue-50/50 ring-1 ring-pipedrive-blue/30'
                : 'border-app-border hover:border-app-text-subtle/50'
            }`}
          >
            <span
              className={`absolute left-3 top-3.5 inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full border ${
                selected ? 'border-pipedrive-blue bg-pipedrive-blue' : 'border-app-text-subtle/60 bg-app-surface'
              }`}
            >
              {selected ? <span className="h-1.5 w-1.5 rounded-full bg-app-surface" /> : null}
            </span>
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0 flex-1">
                <div className="text-sm font-semibold text-app-text">{preset.name}</div>
                <p className="mt-1 text-xs leading-relaxed text-app-text-subtle">{preset.description}</p>
              </div>
              <span
                className={`shrink-0 rounded-full px-2 py-0.5 text-[10px] font-medium ${ACCESS_CHIP[preset.default_platform_access]}`}
              >
                {ACCESS_LABEL[preset.default_platform_access]}
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
}
